import * as S from './FoodOfferUI.styles';

import {PersuationOfferItem} from '@stencil/hotels-cg-reducer/src/details/types';
import {getIconFromName} from '@stencil/hotels-utils/src/name-to-icon-map-food';

interface FoodOfferProps {
  offers: PersuationOfferItem[];
}
export default function FoodOfferUI({offers}: FoodOfferProps) {
  return (
    <>
      <S.MenuUIWrapper data-testid="d-FoodOfferUI-wrap">
        <S.HeadingWrap>
          <S.MenuHeader>Offers</S.MenuHeader>
        </S.HeadingWrap>
        <S.offerContent>
          {offers.map((item, index) => (
            <li key={index.toString()}>
              <span>{item?.icon && getIconFromName(item.icon)}</span>
              <S.OfferText>{item?.text && item.text}</S.OfferText>
            </li>
          ))}
        </S.offerContent>
      </S.MenuUIWrapper>
    </>
  );
}
